import latinize from 'latinize';
import Head from 'next/head';
import Nav from './NavBar';

export default function Header({
  title,
  description,
  contentFirst,
}: {
  title?: string;
  description: string;
  contentFirst?: boolean;
}) {
  const normalizedTitle = latinize(title || '');
  const normalizedDescription = latinize(description || '');

  const finalTitle = contentFirst ? normalizedTitle + ' | Thaqalayn' : 'Thaqalayn | ' + normalizedTitle;

  return (
    <>
      <Head>
        <title>{normalizedTitle ? finalTitle : 'Thaqalayn'}</title>
        <link href="/favicon.ico" rel="icon" />
        <meta content={normalizedDescription} name="description" />
        <meta content="https://thaqalayn.net/scale-preview.png" property="og:image" />
      </Head>
      <Nav />
    </>
  );
}
